import React from 'react';
import { ScrollReveal } from './useScrollReveal';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    emoji: '🚨',
    title: 'BONO 1 — Kit SOS Calma en 10 Minutos',
    desc: 'Protocolo de emergencia emocional paso a paso para crisis de ira, ansiedad o bloqueo. Para usar en el momento exacto que más lo necesitás.',
    value: '$27'
  }, {
    num: '02',
    emoji: '🪞',
    title: 'BONO 2 — Autoestima a Prueba de Redes',
    desc: 'Workbook práctico anti-comparación. Ejercicios concretos para construir identidad que no depende de ningún like ni de la validación digital.',
    value: '$27'
  }, {
    num: '03',
    emoji: '💬',
    title: 'BONO 3 — Conversaciones Difíciles Sin Pelear',
    desc: 'Scripts listos para las 10 situaciones más tensas entre padres/docentes y adolescentes. Las palabras exactas para cada momento difícil.',
    value: '$37'
  }, {
    num: '04',
    emoji: '🗓️',
    title: 'BONO 4 — Semana Calma',
    desc: 'Planner semanal con checklists de mañana, tarde y noche para bajar la ansiedad y los conflictos en casa y en el aula. Imprimible y rellenable.',
    value: '$17'
  }, {
    num: '05',
    emoji: '🚪',
    title: 'BONO 5 — Límites Sin Culpa',
    desc: 'Guía práctica para decir NO con respeto y seguridad. Scripts, tarjetas recortables y fórmulas para cada tipo de presión o manipulación.',
    value: '$17'
  }, {
    num: '06',
    emoji: '📊',
    title: 'BONO 6 — Un Año de Progreso Emocional',
    desc: 'Tracker completo de 12 meses para medir avances reales en regulación, autoestima, relaciones, ansiedad y propósito. Evidencia visible del crecimiento.',
    value: '$47'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative overflow-hidden cv-auto" data-id="element-19">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-cosmic-500/5 to-transparent pointer-events-none" data-id="element-20" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-21">
        <ScrollReveal direction="up" className="text-center mb-16" data-id="element-22">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 flex items-center justify-center gap-3" data-id="element-23">
            <span data-id="element-24">🎁</span> 6 BONOS DE ACCIÓN
          </h2>
          <div className="inline-block bg-cosmic-500/20 text-cosmic-400 font-bold px-4 py-1.5 rounded-full text-lg tracking-widest" data-id="element-25">
            SIEMPRE INCLUIDOS
          </div>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-26">
          {bonuses.map((bonus, index) => <ScrollReveal key={index} direction="up" delay={index + 1} className="bg-navy-800 border border-navy-600 rounded-2xl p-6 relative overflow-hidden group hover:border-cosmic-500/50 transition-colors" data-id="element-27">
              <div className="absolute -right-4 -top-4 text-8xl font-black text-navy-700/50 group-hover:text-navy-700 transition-colors" data-id="element-28">
                {bonus.num}
              </div>

              <div className="relative z-10" data-id="element-29">
                <div className="text-3xl mb-4" data-id="element-30">{bonus.emoji}</div>
                <h3 className="text-xl font-bold text-white mb-3 pr-8" data-id="element-31">
                  {bonus.title}
                </h3>
                <p className="text-slate-400 text-sm mb-6 min-h-[80px]" data-id="element-32">
                  {bonus.desc}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-navy-700" data-id="element-33">
                  <span className="text-slate-500 line-through text-sm" data-id="element-34">
                    {bonus.value}
                  </span>
                  <span className="bg-green-500/20 text-green-400 font-bold px-3 py-1 rounded text-sm" data-id="element-35">
                    GRATIS
                  </span>
                </div>
              </div>
            </ScrollReveal>)}
        </div>

        <ScrollReveal direction="up" className="bg-gradient-to-r from-cosmic-600/20 via-purple-500/20 to-cosmic-600/20 border border-cosmic-500/30 rounded-2xl p-8 text-center max-w-3xl mx-auto glow-cosmic" data-id="element-36">
          <p className="text-xl md:text-2xl font-medium text-slate-300" data-id="element-37">
            Valor total bonos{' '}
            <span className="line-through text-slate-500 mx-2" data-id="element-38">$172</span>
            <span className="text-cosmic-400 font-bold block md:inline mt-2 md:mt-0" data-id="element-39">
              → GRATIS con tu MegaPack
            </span>
          </p>
        </ScrollReveal>
      </div>
    </section>;
}